import { render, staticRenderFns } from "./Profits.vue?vue&type=template&id=c692f1ec&scoped=true"
import script from "./Profits.vue?vue&type=script&lang=js"
export * from "./Profits.vue?vue&type=script&lang=js"
import style0 from "./Profits.vue?vue&type=style&index=0&id=c692f1ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c692f1ec",
  null
  
)

export default component.exports